import { InstrumentCategoryEnum } from '../../types';
import { PortfolioCompositionGridItem } from '../../types/portfolio/portfolioCompositionGridItem';

export const getCalculatedValue = (inventory: PortfolioCompositionGridItem): number => {
  if (
    inventory.instrumentCategory === InstrumentCategoryEnum.Option ||
    inventory.instrumentCategory === InstrumentCategoryEnum.Futures
  ) {
    return inventory.pNL ? Math.abs(inventory.pNL) : 0;
  }

  return inventory.valueInHuf;
};

const sumPortfolioGridItemWeight = (portfolio: Array<PortfolioCompositionGridItem>) => {
  return portfolio.reduce((previousValue, currentValue) => {
    if (
      (currentValue.instrumentCategory === InstrumentCategoryEnum.Option ||
        currentValue.instrumentCategory === InstrumentCategoryEnum.Futures) &&
      currentValue.pNL
    ) {
      // sometimes exchangeRate is zero, so we use 1 as a fallback
      return previousValue + Math.abs(currentValue.pNL * (currentValue.exchangeRate ? currentValue.exchangeRate : 1));
    }

    return previousValue + currentValue.valueInHuf;
  }, 0);
};

/**
 * Calculate portfolio weight by updating the passed portfolio.
 * Doesn't create a new instance, updates the passed one because of performance reasons.
 * @param portfolio
 */
const calculatePortfolioWeight = (portfolio: Array<PortfolioCompositionGridItem>): void => {
  const sumValue = sumPortfolioGridItemWeight(portfolio);
  portfolio.forEach(item => {
    const value = getCalculatedValue(item);
    item.weight = Math.abs(value / sumValue);
  });
};

export const PortfolioUtils = {
  calculatePortfolioWeight,
};
